<template>
  <div id="app">
    <!-- 启动页（已注释）
    <div v-if="showSplash" class="splash-screen" :class="{ 'splash-fade-out': splashFadeOut }">
      <img class="splash-logo" src="/static/image/launch/launch_new_logo.png" :class="{ 'splash-logo-show': showLogo }" @error="handleLogoError" @load="handleLogoLoad" />
      <div class="splash-brand">
          <div class="splash-brand-title">官方直营 品牌信誉</div>
          <div class="splash-brand-sub">
            <span class="brand-line"></span>
            <span class="brand-url">www.489vipcn.com</span>
            <span class="brand-line"></span>
          </div>
      </div>
      <div class="splash-progress-wrap">
        <div class="splash-progress-bar">
          <div class="splash-progress-fill" :style="{ width: progress + '%' }"></div>
          <span class="splash-progress-text" :style="{ left: progress + '%' }">{{ Math.floor(progress) }}%</span>
        </div>
      </div>
    </div>
    -->
    <div v-if="$store.state.appInfo.site_state == 1">
      <div class="app-load-wrap" v-if="loading">
        <!-- <van-loading size="24px" vertical color="#DFB372" text-color="#DFB372">加载中...</van-loading> -->
        <div class="app-load-bars">
          <div class="app-load-bar app-load-bar1"></div>
          <div class="app-load-bar app-load-bar2"></div>
          <div class="app-load-bar app-load-bar3"></div>
          <div class="app-load-bar app-load-bar4"></div>
          <div class="app-load-bar app-load-bar5"></div>
        </div>
      </div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="$route.name" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="$route.name" />
    </div>
    <div v-if="$store.state.appInfo.site_state == 0" style="box-sizing: border-box; padding: 30px; fong-size: 26px">{{ $store.state.appInfo.repair_tips }}</div>

    <van-popup v-model="loginNewShow" round style="background: transparent" :close-on-click-overlay="true">
      <loginNewComponents v-if="loginNewShow" :defaultType="loginDefaultType" @close="loginNewShow = false"></loginNewComponents>
      <div class="close-loginNew" @click="loginNewShow = false"><van-icon name="close" color="#fff" size="30" /></div>
    </van-popup>

    <van-popup v-model="depositNewShow" position="bottom" :style="{ background: 'transparent', width: '100%', height: 'calc(100vh - 1rem)', borderRadius: '0' }" @open="onDepositPopupOpen">
      <depositNewComponents ref="depositNewRef" @close="depositNewShow = false" @refreshUser="getUserInfo"></depositNewComponents>
    </van-popup>
    
  </div>
</template>

<script>
import loginNewComponents from "./components/libs/loginNew.vue";
import depositNewComponents from "./components/libs/depositNew.vue";
export default {
  name: 'App',
  components: {
		loginNewComponents,
		depositNewComponents,
	},
  data() {
    return {
      daoTime: null,
      loading: false,
      pid: '',
      loginNewShow: false,
      loginDefaultType: 1,
      depositNewShow: false,
      // 第三方支付回跳待处理订单号
      paybackOrderNo: '',
      // 启动页相关
      showSplash: false,
      showLogo: false,
      progress: 0,
      splashFadeOut: false,
      splashTimer: null,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;

    // 启动页已注释
    // if (this.isOpenInAppWebView()) {
    //   this.startSplash();
    // }

    that.getApp();
    that.getGameList(); // 获取游戏列表
    if (sessionStorage.getItem('token')) {
      that.openDaoTime();
      that.getUserInfo();
    }
    // 第三方支付完成回跳：/?payback=订单号
    if (query.payback && sessionStorage.getItem('token')) {
      that.paybackOrderNo = String(query.payback);
      that.depositNewShow = true;
    }
    if (query.pid) {
      that.pid = query.pid;
      sessionStorage.setItem('pid', query.pid);
      that.$router.push({ path: `/?pid=${query.pid}` });
    } else if (sessionStorage.getItem('pid')) {
      that.pid = sessionStorage.getItem('pid');
    }
    //that.getVisitUrl();
  },
  methods: {
    // 存款弹窗打开：拉通道；若为支付回跳则自动开记录并轮询
    onDepositPopupOpen() {
      this.$nextTick(() => {
        const ref = this.$refs.depositNewRef;
        if (!ref) return;
        ref.getOnlineChannels();
        if (this.paybackOrderNo) {
          const orderNo = this.paybackOrderNo;
          this.paybackOrderNo = '';
          this.$nextTick(() => {
            this.$refs.depositNewRef && this.$refs.depositNewRef.handlePayback(orderNo);
          });
        }
      });
    },
    getVisitUrl() {
      let that = this;
      that.$apiFun
        .get('/api/getVisitUrl', {})
        .then(res => {
          if (res.code == 200) {
            let url = that.pid ? res.data.url + 'register?pid=' + that.pid : res.data.url;
            window.open(url, '_self');
          }
        })
        .catch(res => {
          // console.log(res)
        });
    },
    // 获取游戏列表
    getGameList() {
      let that = this;

      that.$apiFun.get('/api/game/list', { category: '' }).then(res => {

        if (res.code == 200) {
          let list = res.data;
          // console.log(list);
          // 模板中各section对应的store变量名（与模拟数据保持一致）:
          // 电子游戏→realbetList, 棋牌游戏→jokerList, 捕鱼游戏→gamingList
          // 真人游戏→sportList, 区块链游戏→conciseList, 体育游戏→tiyuList, 彩票游戏→lotteryList
          let realbetList = [];   // 电子游戏
          let jokerList = [];     // 棋牌游戏
          let gamingList = [];    // 捕鱼游戏
          let sportList = [];     // 真人游戏
          let lotteryList = [];   // 彩票游戏
          let conciseList = [];   // 区块链游戏
          let tiyuList = [];      // 体育游戏
          list.forEach(el => {
            // 补充模板需要的字段
            el.game_name = el.name || el.platform_name || '';
            el.has_name = 1;
            el.is_favorite = el.is_favorite || 0;
            el.tag = el.tag || '';
            el.is_hot = el.is_hot || 0;
            el.is_recent = el.is_recent || 0;

            if (el.app_state != 1) return;

            // 数据库category_id → 模板store变量映射
            if (el.category_id == 'gaming') {
              realbetList.push(el);       // 电子游戏
            } else if (el.category_id == 'concise') {
              jokerList.push(el);         // 棋牌游戏
            } else if (el.category_id == 'joker') {
              gamingList.push(el);        // 捕鱼游戏
            } else if (el.category_id == 'realbet') {
              sportList.push(el);         // 真人游戏
            } else if (el.category_id == 'esports') {
              conciseList.push(el);       // 区块链/电竞游戏
            } else if (el.category_id == 'sport') {
              tiyuList.push(el);          // 体育游戏
            } else if (el.category_id == 'lottery') {
              lotteryList.push(el);       // 彩票游戏
            }
          });

          localStorage.setItem('realbetList', JSON.stringify(realbetList));
          localStorage.setItem('jokerList', JSON.stringify(jokerList));
          localStorage.setItem('gamingList', JSON.stringify(gamingList));
          localStorage.setItem('sportList', JSON.stringify(sportList));
          localStorage.setItem('lotteryList', JSON.stringify(lotteryList));
          localStorage.setItem('conciseList', JSON.stringify(conciseList));
          localStorage.setItem('tiyuList', JSON.stringify(tiyuList));
          that.$store.commit('changGameList');
          
        }
      });
    },
    // 获取app
    getApp() {
      let that = this;
      that.$apiFun.post('/api/app', {}).then(res => {
        if (res.code == 200) {
          localStorage.setItem('appInfo', JSON.stringify(res.data));
          that.$store.commit('changappInfo');
          document.getElementsByTagName('title')[0].innerText = that.$store.state.appInfo.title;
        }
      });
    },
    // 退出登录
    outLogin() {
      let that = this;

      that.$dialog
        .confirm({
          title: '温馨提示',
          message: '是否退出当前账号?',
          confirmButtonText: '确认退出',
          // confirmButtonColor: '#292A2C',
          cancelButtonText: '我点错了',
          // cancelButtonColor: '#DFB372',
          theme: 'round-button',
        })
        .then(() => {
          that.showLoading();

          that.$apiFun
            .post('/api/logoff', {})
            .then(res => {
              localStorage.clear();
              sessionStorage.clear();
              that.$store.commit('changUserInfo');
              that.$store.commit('changToken');
              that.closeDaoTime();
              that.hideLoading();
              that.$router.push({ path: '/' });
            })
            .catch(() => {
              localStorage.clear();
              sessionStorage.clear();
              // that.$cookies.remove('token' )/
              that.$store.commit('changUserInfo');
              that.$store.commit('changToken');
              that.closeDaoTime();
              that.hideLoading();
              that.$router.push({ path: '/' });
            });
        })
        .catch(() => {});
    },
    // 打开游戏
    openGamePage(name, type, code) {
      let that = this;
      let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
      if (!token) {
        that.showTost(0, '请登录！');

        return;
      }
      that.goNav(`/gamePage?name=${name}&type=${type}&code=${code}`);
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();
      document.execCommand('copy');
      this.showTost(1, '复制成功！');
    },
    goNav(url) {
      let that = this;
      if (url == '/withdraw') {
        // console.log(url,'hhhh')
        // console.log(that.$store.state.token,'hhhh888')
        if (!that.$store.state.token) {
          // console.log('没有token')
          that.loginNewShow = true;
          // this.$router.push({ path: '/' });
        }else{
          this.$router.push({ path: url });
        }
         return;
      }
      if (url == '/recharge') {
        if (!that.$store.state.token) {
          that.loginNewShow = true;
        } else {
          that.depositNewShow = true;
        }
        return;
      }
      if (url == '/hongbao' || url == '/transfer') {
        if (!that.$store.state.token) {
          that.$dialog
            .confirm({
              message: '精彩内容等你来体验，快来登录吧！',
            })
            .then(() => {
              this.$router.push({ path: '/' });
            });

          return;
        }
        if (url == '/hongbao' && that.$store.state.appInfo.redpacket_switch == 0) {
          that.showTost(0, '红包已关闭');
          return;
        }
      }
      if (url == this.$route.fullPath) {
        that.showTost(0, '已在当前页面！');
        return;
      }

      this.$router.push({ path: url });
    },
    closeDaoTime() {
      let that = this;
      if (that.daoTime != null) {
        clearInterval(that.daoTime);
      }
      that.daoTime = null;
    },
    // 不刷新页面更新用户余额
    getBalance() {
      let that = this;
      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          if (res.code == 401) {
            localStorage.clear();
            sessionStorage.clear();
            that.$store.commit('changUserInfo');
            that.$store.commit('changToken');
            that.closeDaoTime();
            that.$router.push({ path: '/' });
          }
        })
        .catch(res => {});
    },
    openDaoTime() {
      let that = this;
      that.daoTime = setInterval(() => {
        that.getBalance();
      }, 100000);
    },
    // 不刷新页面跟新用户信息
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
        }
      });
    },
    // 刷新页面更新信息
    getUserInfoShowLoding() {
      let that = this;
      that.showLoading();
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
          that.hideLoading();
        }
      });
    },
    // 获取代理
    getAgentLoginUrl() {
      let that = this;
      that.$parent.goNav(`/gamePage?dailiD=1`);
    },
    openKefu() {
      let that = this;
      if (!that.$store.state.token) {
        that.loginNewShow = true;
      } else {
        that.$router.push({ path: '/notice', query: { noticeType: '4', from: 'home' } });
      }
    },
    showTost(type, title) {
      let str = type ? 'success' : 'danger';
      // zIndex 必须比弹框遮罩 (9999) 大，避免被遮挡
      this.$notify({ type: str, message: title, zIndex: 999999, duration: 2500 });
    },
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    // ===== 启动页相关方法已注释 =====
    // // 检测是否在APP内嵌WebView打开
    // isOpenInAppWebView() {
    //   const ua = navigator.userAgent.toLowerCase();
    //   // 检查是否为原生 APP webview
    //   const isAndroid = /android/.test(ua);
    //   const isIOS = /iphone|ipad|ipod/.test(ua);
    //   const androidWV = isAndroid && /; wv\)/.test(ua);
    //   const iosWV = isIOS && window.webkit && window.webkit.messageHandlers;
    //   // 也可以检查自定义 UA 标识
    //   const hasAppUA = /app_webview|native_app|489vip/i.test(ua);
    //   return androidWV || !!iosWV || hasAppUA;
    // },
    // // logo加载成功
    // handleLogoLoad() {
    //   // console.log('logo加载成功');
    // },
    // // logo加载失败
    // handleLogoError() {
    //   // console.log('logo加载失败');
    // },
    // // 启动页逻辑
    // startSplash() {
    //   this.showSplash = true;
    //   // 2秒后显示logo
    //   setTimeout(() => { this.showLogo = true; }, 2000);
    //   // 进度条：5秒走完，每50ms更新
    //   this.splashTimer = setInterval(() => {
    //     this.progress += (50 / 5000) * 100;
    //     if (this.progress >= 100) {
    //       this.progress = 100;
    //       clearInterval(this.splashTimer);
    //       this.splashTimer = null;
    //       // 淡出动画
    //       setTimeout(() => {
    //         this.splashFadeOut = true;
    //         setTimeout(() => {
    //           this.showSplash = false;
    //           this.splashFadeOut = false;
    //         }, 300);
    //       }, 200);
    //     }
    //   }, 50);
    // },
    // ===== 启动页相关方法注释结束 =====
  },
  mounted() {
    // 为PC浏览器：用 iframe 把移动端页面严格按手机宽度显示到页面中间（两侧纯黑）
    let userAgentInfo = window.navigator.userAgent;
    let Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod');
    // PC 且 不在 iframe 内（防止无限嵌套）
    const isPC = !Agents.some(item => userAgentInfo.toLowerCase().includes(item.toLowerCase()));
    const inIframe = !!(self.frameElement && self.frameElement.tagName == 'IFRAME');
    if (isPC && !inIframe) {
      // 清掉之前可能生成的 iframe，避免重复
      let ifrTag = document.getElementsByTagName('iframe')[0];
      if (ifrTag) {
        ifrTag.remove();
      } else {
        // body 直接用纯黑背景，页面中仅保留一个居中的 750 × 全屏高 iframe
        document.body.innerHTML = '';
        document.body.style.cssText = [
          'margin:0',
          'padding:0',
          'background:#000',
          'width:100%',
          'height:100vh',
          'display:flex',
          'align-items:flex-start',
          'justify-content:center',
          'overflow:auto'
        ].join(';') + ';';

        ifrTag = document.createElement('iframe');
        ifrTag.setAttribute('src', window.location.href);
        ifrTag.setAttribute('frameborder', '0');
        ifrTag.setAttribute('allow', 'clipboard-read; clipboard-write');
        Object.entries({
          width: '420px',
          maxWidth: '100%',
          height: '100vh',
          minHeight: '640px',
          border: '0 none',
          outline: '0 none',
          display: 'block',
          background: '#0a0a0a',
          boxShadow: 'none'
        }).forEach(([k, v]) => { ifrTag.style[k] = v; });
        document.body.appendChild(ifrTag);
        // 挂载后不再继续后续生命周期逻辑（已清空 body）
        return;
      }
    }
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
    if (that.splashTimer) {
      clearInterval(that.splashTimer);
    }
    that.splashTimer = null;
  },
};
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  background-color: #0a0a0a;
}
/* @import '../static/css/registermember.css';
 @import '../static/css/registermember.css';
 @import '../static/css/registermember.css';
 @import '../static/css/registermember.css'; */

#app {
  max-width: 750px;
  margin: 0 auto;
  min-height: 100vh;
  position: relative;
  background-color: #0a0a0a;
}

.app-load-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
}

.app-load-bars {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 50px;
}

.app-load-bar {
  width: 8px;
  border-radius: 4px;
  animation: appLoadWave 1.2s ease-in-out infinite;
}

.app-load-bar1 {
  background: #2255FF;
  box-shadow: 0 0 6px #2255FF;
  animation-delay: 0s;
}

.app-load-bar2 {
  background: #33CC33;
  box-shadow: 0 0 6px #33CC33;
  animation-delay: 0.15s;
}

.app-load-bar3 {
  background: #FF3322;
  box-shadow: 0 0 6px #FF3322;
  animation-delay: 0.3s;
}

.app-load-bar4 {
  background: #FF8800;
  box-shadow: 0 0 6px #FF8800;
  animation-delay: 0.45s;
}

.app-load-bar5 {
  background: #CC55FF;
  box-shadow: 0 0 6px #CC55FF;
  animation-delay: 0.6s;
}

@keyframes appLoadWave {
  0%, 100% { height: 10px; }
  50% { height: 50px; }
}
.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #069b71;
}

.step .van-tab--active {
  color: #fff;
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUwIiBoZWlnaHQ9IjM2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0wIDB2MzZoMjQwLjgzN0wyNTAgMThsLTkuMTYzLTE4eiIgZmlsbD0iIzA2OUI3MSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+) no-repeat 100% / cover;
}

.step .van-tabs--line .van-tabs__wrap {
  height: 27px;
}
.metransRecord .van-tabs__nav--card .van-tab.van-tab--active {
  color: #fff;
  background-color: #069b71;
  border-radius: 22px;
}
.metransRecord .van-tabs__nav--card {
  border: none;
}
.metransRecord .van-tabs__nav--card .van-tab {
  border: none;
}
.metransRecord .van-tabs__nav--card .van-tab {
  color: #fff;
}

/* 页眉 */

.pageTop {
  background-color: #232429;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  height: 40px;
  line-height: 40px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 200;
}

.acts .van-tabs__line {
  background-color: #DFB372 !important;
}
.acts .van-tab--active {
  color: #DFB372 !important;
}

.van-nav-bar .van-icon {
  color: #BEBEBE;
}
.van-nav-bar {
  background-color: #1e1f24 !important;
}
.van-nav-bar__arrow {
  font-size: 24px;
  color: #fff !important;
}
.van-nav-bar__title {
  font-size: .40rem;
  color: #fff !important;
}
.van-nav-bar .van-icon {
  color: #fff !important;
}

.bancgs {
  position: fixed;
  top: 10px;
  left: 10px;
  width: 30px;
  opacity: 0.8;
  z-index: 200;
}
p {
  margin-block-start: 5px !important;
  margin-block-end: 5px !important;
}
.inputsw {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 999;
  cursor: pointer;
}
.van-tab--active {
  color: #d1ae52;
}
.van-tabs__line {
  background-color: #d1ae52;
}
.promote-page .van-tabs__line {
  background-color: #DFB372 !important;
}
.promote-page .van-tab--active {
  color: #DFB372 !important;
}
.van-cell {
  padding: 5px 8px;
}
.sdg .van-field__label {
  width: 0.2rem;
}
[class*='van-hairline']:after {
  border: none;
}
.sdgg .van-popup {
  border-radius: 15px 15px 0 0;
}

.stddss .van-field__control {
  font-size: 0.5rem;
}

.van-button--info {
  color: #1E1F24;
  background: linear-gradient(180deg, #FBDDB2 0%, #F2CC95 50%, #DFB372 100%)!important;
  border-radius: .6rem;
  border:0;
}

.van-button--plain.van-button--primary{color: #DFB372;border: 1px solid #DFB372; border-radius: .6rem;}
.van-button--plain{background-color: transparent;}

.close-loginNew{text-align: center;margin-top: .3rem;}

.van-dialog{background-color: #292A2C !important; border: 1px solid #3B3C3D;color: #fff;}
.van-dialog__header{font-size: .4rem;}
.van-dialog--round-button .van-dialog__footer{background-color: #292A2C;}
.van-dialog--round-button .van-dialog__message{color: #999 !important;}
.van-dialog__message--has-title{color: #fff;margin-top: .3rem;}
.van-goods-action-button--warning{background: #DFB372!important;color: #292A2C;}
.van-goods-action-button--danger{background: #292A2C!important;color: #DFB372;border: 1px solid #DFB372 !important;}

/* ===== 启动页样式已注释
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  background: url('/static/image/launch/launch_new_bg.png') no-repeat center center / cover;
  background-color: #0a0a0a;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}
.splash-screen.splash-fade-out {
  opacity: 0;
  pointer-events: none;
}
.splash-logo {
  position: absolute;
  top: 11.5%;
  left: 50%;
  transform: translateX(-50%) translateY(0.2rem);
  z-index: 2;
  width: 70%;
  height: auto;
  object-fit: contain;
  opacity: 0;
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.splash-logo.splash-logo-show {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
.splash-brand {
  position: absolute;
  top: 20%;
  left: 0;
  width: 100%;
  text-align: center;
  z-index: 2;
}
.splash-brand-title {
  background: linear-gradient(180deg, #ffffff 0%, #dcdee0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  -webkit-text-stroke: 0.01rem #dcdee0;
  paint-order: stroke fill;
  font-size: 0.65rem;
  font-weight: bold;
  font-family: "方正粗黑宋", "思源宋体", SimSun, serif;
  letter-spacing: 0.01rem;
  margin-bottom: 0.2rem;
}
.splash-brand-sub {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
}
.splash-brand-sub .brand-line {
  width: 1.2rem;
  height: 1px;
}
.splash-brand-sub .brand-line:first-child {
  background: linear-gradient(to left, #ffffff, transparent);
}
.splash-brand-sub .brand-line:last-child {
  background: linear-gradient(to right, #ffffff, transparent);
}
.splash-brand-sub .brand-url {
  background: linear-gradient(180deg, #ffffff 0%, #dcdee0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 0.35rem;
  letter-spacing: 0.05rem;
}
.splash-progress-wrap {
  position: absolute;
  bottom: 2rem;
  width: 70%;
  left: 15%;
}
.splash-progress-bar {
  width: 100%;
  height: 0.25rem;
  background: hsla(0, 0%, 100%, 0.2);
  border-radius: 0.1rem;
  overflow: visible;
  position: relative;
}
.splash-progress-fill {
  height: 100%;
  background: #02C005;
  border-radius: 0.1rem;
  transition: width 0.05s linear;
  position: relative;
}
.splash-progress-text {
  position: absolute;
  bottom: 100%;
  transform: translateX(0);
  background: #02C005;
  border: 1px solid #02C005;
  color: #fff;
  font-size: 0.28rem;
  font-weight: 400;
  padding: 0 0.25rem;
  border-radius: 0.15rem;
  white-space: nowrap;
  text-align: center;
  margin-bottom: 0.05rem;
}
===== 启动页样式注释结束 */

</style>



// WEBPACK FOOTER //
// src/App.vue